var faqService = function ($q, cacheManagerService) {
    this.getCategories = function (employerView) {
        var deferred = $q.defer();

        cacheManagerService.get({
            url: siteGlobal.apiResourceLocation + '/api/FAQ/GetCategories',
            params: { EmployerView: employerView }
        })
        .then(
            function (data) {
                deferred.resolve(data);
            },
            function (data, status, headers, config) {
                siteGlobal.logError(data, "faqService.getCategories", { data: data, status: status, headers: headers, config: config });
            });

        return deferred.promise;
    };

    this.filterByCategory = function (catid, employerView) {
        var deferred = $q.defer();
        
        cacheManagerService.get({
            noCache: true,
            url: siteGlobal.apiResourceLocation + '/api/FAQ/FilterByCategory',
            params: { ID: catid, EmployerView: employerView }
        })
        .then(
            function (data) {
                deferred.resolve(data);
            },
            function (data, status, headers, config) {
                siteGlobal.logError(data, "faqService.filterByCategory", { data: data, status: status, headers: headers, config: config });
            });

        return deferred.promise;
    };

    this.search = function (search, employerView) {
        var deferred = $q.defer();

        cacheManagerService.get({
            url: siteGlobal.apiResourceLocation + '/api/FAQ/Search',
            params: { Search: search, EmployerView: employerView }
        })
         .then(
            function (data) {
                deferred.resolve(data);
            },
            function (data, status, headers, config) {
                siteGlobal.logError(data, "faqService.search", { data: data, status: status, headers: headers, config: config });
            });

        return deferred.promise;
    };
};

